module.exports = __webpack_public_path__ + "static/media/message-square-black.4432870b.svg";